import { useCallback, useEffect } from "react";
import { analyticsService } from "../services/AnalyticsService";

export const useUnload = (onClose: any) => {
  const onBeforeUnload = useCallback((event: any) => {
    event.preventDefault();
    return (event.returnValue = "Are you sure you want to exit?");
  }, []);

  const onUnload = useCallback(() => {
    analyticsService.track("SES - User Left Page", {}, () => {});
    if (onClose) {
      onClose();
    }
  }, []);

  const register = useCallback(() => {
    window.addEventListener("beforeunload", onBeforeUnload);
    window.addEventListener("unload", onUnload);
  }, []);

  const deregister = useCallback(() => {
    window.removeEventListener("beforeunload", onBeforeUnload);
    window.removeEventListener("unload", onUnload);
  }, []);

  useEffect(() => {
    register();

    return () => {
      deregister();
    };
  }, []);

  return { deregister };
};
